import {
  Button,
  Form,
  PasswordInput,
  TextInput,
  InlineNotification,
} from '@carbon/react';
import { PageHeader } from 'components/page-header';
import { useSetAtom } from 'jotai';
import { EnergyLinkAccessCheck } from 'pages/energy-link/energy-link-access-check';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useHistory } from 'react-router-dom';
import { pageTitle } from 'utils/page-title';
import { createAccountAtom, ACCOUNTS_URL, accountsAtom } from '../../atoms';
import styles from './energy-link-new-page.module.scss';

const EnergyLinkAccountsNewPage = () => {
  const history = useHistory();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createAccount = useSetAtom(createAccountAtom);
  const fetchAccounts = useSetAtom(accountsAtom);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    createAccount({
      url: ACCOUNTS_URL,
      type: 'POST',
      data: { username, password },
      onSuccess: () => {
        history.push('/energy_link/accounts');
        fetchAccounts();
      },
      onError: (error) => {
        setIsSubmitting(false);
        setError(
          error?.message || 'Failed to create account. Please try again.'
        );
      },
    });
  };

  return (
    <EnergyLinkAccessCheck>
      <Helmet>
        <title>{pageTitle('New Energy Link Account')}</title>
      </Helmet>
      <PageHeader
        breadcrumbs={[
          ['/energy_link', 'Energy Link'],
          ['/energy_link/accounts', 'Accounts'],
          ['/energy_link/accounts/new', 'New Account'],
        ]}
        title="New Energy Link Account"
        actions={null}
      />
      <Form onSubmit={handleSubmit}>
        <div className={styles.formContainer}>
          {error && (
            <InlineNotification
              kind="error"
              title="Error"
              subtitle={error}
              hideCloseButton={false}
              onCloseButtonClick={() => setError(null)}
            />
          )}
          <TextInput
            id="username"
            labelText="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <div className={styles.passwordField}>
            <PasswordInput
              id="password"
              labelText="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className={styles.submitButton}>
            <Button type="submit" disabled={isSubmitting}>
              Create Account
            </Button>
          </div>
        </div>
      </Form>
    </EnergyLinkAccessCheck>
  );
};

export { EnergyLinkAccountsNewPage };
